import { Box, Typography } from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";

const StyledWrapper = styled(Box)`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  .MuiCircularProgress-circle {
    opacity: 0.5;
  }
`;

const StyledHorizontalWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const StyledText = styled(Typography)`
  text-align: center;
  font-size: 1rem;
  opacity: 0.5;
`;

interface INotesEmptyProps {}

const NotesEmpty = (props: INotesEmptyProps) => {
  return (
    <StyledWrapper>
      <StyledHorizontalWrapper>
        <StyledText>
          <FormattedMessage
            id="NotesEmpty.Label"
            defaultMessage="Aún no hay ninguna nota"
          />
        </StyledText>
      </StyledHorizontalWrapper>
    </StyledWrapper>
  );
};

export default NotesEmpty;
